// extracted by mini-css-extract-plugin
export default {"ant-table-thead":"card_ant-table-thead__Mm63d","dashboard-page-card":"card_dashboard-page-card__oZxb0"};